﻿const gridLeasingProperties = document.getElementById("gridLeasingProperties");
const inputSearch = document.getElementById("inputSearch");

const { setOptions, importLibrary } = require('../../ga/node_modules/@googlemaps/js-api-loader');
const { MarkerClusterer } = require('../../ga/node_modules/@googlemaps/markerclusterer');



//Date handler
const getLocaleShortDateString = function (d) {
    var f = { "ar-SA": "dd/MM/yy", "bg-BG": "dd.M.yyyy", "ca-ES": "dd/MM/yyyy", "zh-TW": "yyyy/M/d", "cs-CZ": "d.M.yyyy", "da-DK": "dd-MM-yyyy", "de-DE": "dd.MM.yyyy", "el-GR": "d/M/yyyy", "en-US": "M/d/yyyy", "fi-FI": "d.M.yyyy", "fr-FR": "dd/MM/yyyy", "he-IL": "dd/MM/yyyy", "hu-HU": "yyyy. MM. dd.", "is-IS": "d.M.yyyy", "it-IT": "dd/MM/yyyy", "ja-JP": "yyyy/MM/dd", "ko-KR": "yyyy-MM-dd", "nl-NL": "d-M-yyyy", "nb-NO": "dd.MM.yyyy", "pl-PL": "yyyy-MM-dd", "pt-BR": "d/M/yyyy", "ro-RO": "dd.MM.yyyy", "ru-RU": "dd.MM.yyyy", "hr-HR": "d.M.yyyy", "sk-SK": "d. M. yyyy", "sq-AL": "yyyy-MM-dd", "sv-SE": "yyyy-MM-dd", "th-TH": "d/M/yyyy", "tr-TR": "dd.MM.yyyy", "ur-PK": "dd/MM/yyyy", "id-ID": "dd/MM/yyyy", "uk-UA": "dd.MM.yyyy", "be-BY": "dd.MM.yyyy", "sl-SI": "d.M.yyyy", "et-EE": "d.MM.yyyy", "lv-LV": "yyyy.MM.dd.", "lt-LT": "yyyy.MM.dd", "fa-IR": "MM/dd/yyyy", "vi-VN": "dd/MM/yyyy", "hy-AM": "dd.MM.yyyy", "az-Latn-AZ": "dd.MM.yyyy", "eu-ES": "yyyy/MM/dd", "mk-MK": "dd.MM.yyyy", "af-ZA": "yyyy/MM/dd", "ka-GE": "dd.MM.yyyy", "fo-FO": "dd-MM-yyyy", "hi-IN": "dd-MM-yyyy", "ms-MY": "dd/MM/yyyy", "kk-KZ": "dd.MM.yyyy", "ky-KG": "dd.MM.yy", "sw-KE": "M/d/yyyy", "uz-Latn-UZ": "dd/MM yyyy", "tt-RU": "dd.MM.yyyy", "pa-IN": "dd-MM-yy", "gu-IN": "dd-MM-yy", "ta-IN": "dd-MM-yyyy", "te-IN": "dd-MM-yy", "kn-IN": "dd-MM-yy", "mr-IN": "dd-MM-yyyy", "sa-IN": "dd-MM-yyyy", "mn-MN": "yy.MM.dd", "gl-ES": "dd/MM/yy", "kok-IN": "dd-MM-yyyy", "syr-SY": "dd/MM/yyyy", "dv-MV": "dd/MM/yy", "ar-IQ": "dd/MM/yyyy", "zh-CN": "yyyy/M/d", "de-CH": "dd.MM.yyyy", "en-GB": "dd/MM/yyyy", "es-MX": "dd/MM/yyyy", "fr-BE": "d/MM/yyyy", "it-CH": "dd.MM.yyyy", "nl-BE": "d/MM/yyyy", "nn-NO": "dd.MM.yyyy", "pt-PT": "dd-MM-yyyy", "sr-Latn-CS": "d.M.yyyy", "sv-FI": "d.M.yyyy", "az-Cyrl-AZ": "dd.MM.yyyy", "ms-BN": "dd/MM/yyyy", "uz-Cyrl-UZ": "dd.MM.yyyy", "ar-EG": "dd/MM/yyyy", "zh-HK": "d/M/yyyy", "de-AT": "dd.MM.yyyy", "en-AU": "d/MM/yyyy", "es-ES": "dd/MM/yyyy", "fr-CA": "yyyy-MM-dd", "sr-Cyrl-CS": "d.M.yyyy", "ar-LY": "dd/MM/yyyy", "zh-SG": "d/M/yyyy", "de-LU": "dd.MM.yyyy", "en-CA": "dd/MM/yyyy", "es-GT": "dd/MM/yyyy", "fr-CH": "dd.MM.yyyy", "ar-DZ": "dd-MM-yyyy", "zh-MO": "d/M/yyyy", "de-LI": "dd.MM.yyyy", "en-NZ": "d/MM/yyyy", "es-CR": "dd/MM/yyyy", "fr-LU": "dd/MM/yyyy", "ar-MA": "dd-MM-yyyy", "en-IE": "dd/MM/yyyy", "es-PA": "MM/dd/yyyy", "fr-MC": "dd/MM/yyyy", "ar-TN": "dd-MM-yyyy", "en-ZA": "yyyy/MM/dd", "es-DO": "dd/MM/yyyy", "ar-OM": "dd/MM/yyyy", "en-JM": "dd/MM/yyyy", "es-VE": "dd/MM/yyyy", "ar-YE": "dd/MM/yyyy", "en-029": "MM/dd/yyyy", "es-CO": "dd/MM/yyyy", "ar-SY": "dd/MM/yyyy", "en-BZ": "dd/MM/yyyy", "es-PE": "dd/MM/yyyy", "ar-JO": "dd/MM/yyyy", "en-TT": "dd/MM/yyyy", "es-AR": "dd/MM/yyyy", "ar-LB": "dd/MM/yyyy", "en-ZW": "M/d/yyyy", "es-EC": "dd/MM/yyyy", "ar-KW": "dd/MM/yyyy", "en-PH": "M/d/yyyy", "es-CL": "dd-MM-yyyy", "ar-AE": "dd/MM/yyyy", "es-UY": "dd/MM/yyyy", "ar-BH": "dd/MM/yyyy", "es-PY": "dd/MM/yyyy", "ar-QA": "dd/MM/yyyy", "es-BO": "dd/MM/yyyy", "es-SV": "dd/MM/yyyy", "es-HN": "dd/MM/yyyy", "es-NI": "dd/MM/yyyy", "es-PR": "dd/MM/yyyy", "am-ET": "d/M/yyyy", "tzm-Latn-DZ": "dd-MM-yyyy", "iu-Latn-CA": "d/MM/yyyy", "sma-NO": "dd.MM.yyyy", "mn-Mong-CN": "yyyy/M/d", "gd-GB": "dd/MM/yyyy", "en-MY": "d/M/yyyy", "prs-AF": "dd/MM/yy", "bn-BD": "dd-MM-yy", "wo-SN": "dd/MM/yyyy", "rw-RW": "M/d/yyyy", "qut-GT": "dd/MM/yyyy", "sah-RU": "MM.dd.yyyy", "gsw-FR": "dd/MM/yyyy", "co-FR": "dd/MM/yyyy", "oc-FR": "dd/MM/yyyy", "mi-NZ": "dd/MM/yyyy", "ga-IE": "dd/MM/yyyy", "se-SE": "yyyy-MM-dd", "br-FR": "dd/MM/yyyy", "smn-FI": "d.M.yyyy", "moh-CA": "M/d/yyyy", "arn-CL": "dd-MM-yyyy", "ii-CN": "yyyy/M/d", "dsb-DE": "d. M. yyyy", "ig-NG": "d/M/yyyy", "kl-GL": "dd-MM-yyyy", "lb-LU": "dd/MM/yyyy", "ba-RU": "dd.MM.yy", "nso-ZA": "yyyy/MM/dd", "quz-BO": "dd/MM/yyyy", "yo-NG": "d/M/yyyy", "ha-Latn-NG": "d/M/yyyy", "fil-PH": "M/d/yyyy", "ps-AF": "dd/MM/yy", "fy-NL": "d-M-yyyy", "ne-NP": "M/d/yyyy", "se-NO": "dd.MM.yyyy", "iu-Cans-CA": "d/M/yyyy", "sr-Latn-RS": "d.M.yyyy", "si-LK": "yyyy-MM-dd", "sr-Cyrl-RS": "d.M.yyyy", "lo-LA": "dd/MM/yyyy", "km-KH": "yyyy-MM-dd", "cy-GB": "dd/MM/yyyy", "bo-CN": "yyyy/M/d", "sms-FI": "d.M.yyyy", "as-IN": "dd-MM-yyyy", "ml-IN": "dd-MM-yy", "en-IN": "dd-MM-yyyy", "or-IN": "dd-MM-yy", "bn-IN": "dd-MM-yy", "tk-TM": "dd.MM.yy", "bs-Latn-BA": "d.M.yyyy", "mt-MT": "dd/MM/yyyy", "sr-Cyrl-ME": "d.M.yyyy", "se-FI": "d.M.yyyy", "zu-ZA": "yyyy/MM/dd", "xh-ZA": "yyyy/MM/dd", "tn-ZA": "yyyy/MM/dd", "hsb-DE": "d. M. yyyy", "bs-Cyrl-BA": "d.M.yyyy", "tg-Cyrl-TJ": "dd.MM.yy", "sr-Latn-BA": "d.M.yyyy", "smj-NO": "dd.MM.yyyy", "rm-CH": "dd/MM/yyyy", "smj-SE": "yyyy-MM-dd", "quz-EC": "dd/MM/yyyy", "quz-PE": "dd/MM/yyyy", "hr-BA": "d.M.yyyy.", "sr-Latn-ME": "d.M.yyyy", "sma-SE": "yyyy-MM-dd", "en-SG": "d/M/yyyy", "ug-CN": "yyyy-M-d", "sr-Cyrl-BA": "d.M.yyyy", "es-US": "M/d/yyyy" };

    var l = navigator.language ? navigator.language : navigator['userLanguage'], y = d.getFullYear(), m = d.getMonth() + 1, d = d.getDate();
    f = (l in f) ? f[l] : "MM/dd/yyyy";
    function z(s) { s = '' + s; return s.length > 1 ? s : '0' + s; }
    f = f.replace(/yyyy/, y); f = f.replace(/yy/, String(y).substr(2));
    f = f.replace(/MM/, z(m)); f = f.replace(/M/, m);
    f = f.replace(/dd/, z(d)); f = f.replace(/d/, d);
    return f;
}

let shortedDate = getLocaleShortDateString(new Date());
var gmap;
let map;
let markers = [];
let infowindows = [];
let ol = new Array();
let currentMallIdList = "";

let myMarkerClusterer;

simonMallList_mallList.forEach(mall => {
    if (mall.GrossLeasableArea < 500000) {
        mall.glaCategory = "500K";
    } else if (mall.GrossLeasableArea >= 500000 && mall.GrossLeasableArea < 1000000) {
        mall.glaCategory = "500to1mil";
    } else {
        mall.glaCategory = "1milplus";
    }
});

const renderMallList = function (mallList) {
    let text = "";
    let imgXY = 300;
    //if (gridLeasingProperties.hasChildNodes()) {
    //    imgXY = gridLeasingProperties.children[0].offsetWidth;
    //    console.log(gridLeasingProperties.children[0]);
    //    console.log(imgXY);
    //}
    if (mallList.length > 0) {
        mallList.forEach(element => text += `<a href="${element.TargetUrl.length > 0 ? element.TargetUrl : '/leasing/' + element.MallShortName}"><figure
        class="busProperty"
        data-id="${element.Id}">
        <img            
            src="https://assets.simon.com/content/businessimages/placeholder_198x198.jpg"
            alt="${element.DisplayName}"
            height="${imgXY}"
            width="${imgXY}"
            class="w-100 h-100" loading="lazy" />

        <figcaption><h6>${element.DisplayName.replace("®", "<sup>®</sup>")}</h6>
            ${element.City}, ${element.StateCode}
        </figcaption>
        </figure></a>`
        );
    } else {
        text = `<div class='no-match pt-4 text-center'>
                    <h3 class='fs-4'>SO SORRY :(</h3>
                    <p>There are no results that match your keyword(s) and/or applied filter(s). </p>
                    <p>Please either clear your search or remove one or more filter(s).</p>
                </div>`;
    }

    gridLeasingProperties.innerHTML = text;

    mallList.forEach(element => {
        document.querySelector(`figure[data-id="${element.Id}"]`).children[0].src = `${element.MallImagePath}`;
    })

}

const exportToExcel = () => {
    window.location.assign("/search/exportToExcel?mallidarray=" + currentMallIdList);
}
window.exportToExcel = exportToExcel;

const getFilters = async () => {
    const { AdvancedMarkerElement } = await importLibrary('marker');

    let region = document.querySelector("input[name='region']:checked").value;
    let filteredMalls = filteredMallList;
    const propertyTypeChecks = document.getElementsByName("platform");
    const luxuryTypeCheck = document.getElementById("luxurytenants");
    const glaCategoryChecks = document.getElementsByName("glaCategory");
    let propertyTypes = [];
    let glaCategories = [];
    let url = new URL(window.location);
    let numFilters = 0;

    /* Get the property types */
    for (var i = 0; i < propertyTypeChecks.length; i++) {
        if (propertyTypeChecks[i].checked) {
            propertyTypes.push(propertyTypeChecks[i].value);
        }
    }
    if (propertyTypes.length == 0) {
        propertyTypes.push("all");
        url.searchParams.delete('platform');
        window.history.pushState({}, '', url);
    } else {
        url.searchParams.set('platform', propertyTypes.join(','));
        window.history.pushState({}, '', url);
        numFilters += propertyTypes.length;
    }
    filteredMalls = filteredMalls.filter(mall => propertyTypes.includes(mall.PropertyType) || propertyTypes.includes("all"));

    if (!luxuryTypeCheck.checked) {
        url.searchParams.delete('luxurytenants');
        window.history.pushState({}, '', url);
    } else {
        filteredMalls = filteredMalls.filter(mall => mall.HasLuxuryTenants);
        url.searchParams.set('luxurytenants', true);
        window.history.pushState({}, '', url);
        numFilters += 1;
    }

    for (var i = 0; i < glaCategoryChecks.length; i++) {
        if (glaCategoryChecks[i].checked) {
            glaCategories.push(glaCategoryChecks[i].value);
        }
    }
    if (glaCategories.length == 0) {
        glaCategories.push("all");
        url.searchParams.delete('gla');
        window.history.pushState({}, '', url);
    } else {
        url.searchParams.set('gla', glaCategories.join(','));
        window.history.pushState({}, '', url);
        numFilters += 1;
    }
    filteredMalls = filteredMalls.filter(mall => glaCategories.includes(mall.glaCategory) || glaCategories.includes("all"));

    switch (region) {
        case "usa":
            filteredMalls = filteredMalls.filter(mall => mall.CountryCode.toLowerCase() === region);
            url.searchParams.set('region', 'usa');
            window.history.pushState({}, '', url);
            numFilters += 1;
            break;
        case "international":
            filteredMalls = filteredMalls.filter(mall => mall.IsInternational);
            url.searchParams.set('region', 'international');
            window.history.pushState({}, '', url);
            numFilters += 1;
            break;
        default:
            url.searchParams.delete('region');
            window.history.pushState({}, '', url);
            break;
    }

    if (inputSearch.value.length > 0) {
        url.searchParams.set('location', inputSearch.value);
        window.history.pushState({}, '', url);
    } else {
        url.searchParams.delete('location');
    }

    const fc = document.getElementById("filterCount");
    if (numFilters > 0) {
        fc.innerHTML = numFilters;
        fc.classList.remove("d-none");
    } else {
        fc.classList.add("d-none");
    }
    renderMallList(filteredMalls);
    currentMallIdList = filteredMalls.map(e => e.Id).join(",");

    if (gridLeasingProperties.classList.contains("d-none")) {  // only make the Googla Maps calls if the map is visible

        // clear any existing markers
        var infowindow;
        deleteMarkers();

        var pinIcon = new google.maps.MarkerImage(
            "/siteassets/images/map-icon@2x.png",
            null, /* size is determined at runtime */
            null, /* origin is 0,0 */
            null, /* anchor is bottom center of the scaled image */
            new google.maps.Size(30, 37));

        markers = filteredMalls.map(function (element) {
            let iw = new google.maps.InfoWindow({ content: `<a class="text-black spg-ad-spot-link text-decoration-none" href="${element.TargetUrl.length > 0 ? element.TargetUrl : '/leasing/'.concat(element.MallShortName)}">${element.DisplayName.toUpperCase().replace("®", "<sup>®</sup>")}</a><br> ${element.FullAddress}<br><br>GLA: ${element.GrossLeasableArea.toLocaleString("en-us")} sq. ft.<br>(as of ${shortedDate})` });
            infowindows.push(iw);

            function generateMallPinIcon(mall) {
                const div = document.createElement("div");
                div.classList.add("mall-marker");
                div.style.width = "30px";
                div.style.height = "37px";
                div.style.backgroundImage = "url('/siteassets/images/map-icon@2x.png')";
                div.style.backgroundSize = "contain";
                return div;
            }

            let newMarker = new AdvancedMarkerElement({
                position: { lat: element.Latitude, lng: element.Longitude },
                map: gmap,
                content: generateMallPinIcon(element)
            });
            newMarker.addListener('click', function () {
                closeInfoWindows();
                iw.open(gmap, newMarker);
            });
            return newMarker;
        });

        function generateClusterIcon(markers) {
            const div = document.createElement("div");
            div.style.width = "33px";
            div.style.height = "33px";
            div.style.backgroundImage = "url('/siteassets/images/search/r2.png')";
            div.style.backgroundSize = "contain";
            div.style.display = "flex";
            div.style.justifyContent = "center";
            div.style.alignItems = "center";
            let span = document.createElement("span");
            span.innerHTML = markers.length;
            span.style.color = "#ffffff";
            div.appendChild(span);
            return div;
        }

        myMarkerClusterer = new MarkerClusterer({
            map: gmap,
            markers: markers,
            renderer: {
                render: ({ markers, _position: position }) => {
                    return new AdvancedMarkerElement({
                        position: {
                            lat: position.lat(),
                            lng: position.lng(),
                        },
                        content: generateClusterIcon(markers)
                    });
                }
            }
        });

    }

}

const showHideMap = () => {
    const resultsView = document.querySelector("input[name='resultsView']:checked").value;
    let url = new URL(window.location);

    if (resultsView == "mapView") {
        url.searchParams.set('view', 'map');
        document.getElementById("mappanel").classList.remove("d-none");
        document.getElementById("gridLeasingProperties").classList.add("d-none");
        document.getElementById("buttonSort").classList.remove("d-sm-block");
        document.getElementById("buttonSort2").classList.add("d-none");
        getFilters();
    } else {
        url.searchParams.delete('view');
        document.getElementById("mappanel").classList.add("d-none");
        document.getElementById("gridLeasingProperties").classList.remove("d-none");
        document.getElementById("buttonSort").classList.add("d-sm-block");
        document.getElementById("buttonSort2").classList.remove("d-none");
    }
    window.history.pushState({}, '', url);
}
window.showHideMap = showHideMap;

const setClearFilterState = function () {
    if (document.querySelector('#collapseFilter input[type="checkbox"]:checked') || !document.querySelector('#regionAll:checked') || inputSearch.value.length > 0) {
        document.querySelectorAll('.clear-filters').forEach(el => el.classList.remove('d-none'));
    }
    else {
        document.querySelectorAll('.clear-filters').forEach(el => el.classList.add('d-none'));
    }
}

const clearAllFilters = () => {
    // set region to All
    document.getElementById("regionAll").checked = true;
    inputSearch.value = "";
    let propertyTypeChecks = document.getElementsByName("platform");
    let luxuryCheck = document.getElementById("luxurytenants")
    let glaCategoryChecks = document.getElementsByName("glaCategory");
    for (var i = 0; i < propertyTypeChecks.length; i++) {
        propertyTypeChecks[i].checked = false;
    }
    for (var i = 0; i < glaCategoryChecks.length; i++) {
        glaCategoryChecks[i].checked = false;
    }
    luxuryCheck.checked = false;
    deleteMarkers();
    if (myMarkerClusterer != null) {
        myMarkerClusterer.clearMarkers();
    }

    filteredMallList = simonMallList_mallList;
    filteredMallList.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
    initMap();
    getFilters();

    const url = new URL(window.location);
    window.history.pushState({}, 'Filter Change', '/search');
    setClearFilterState();
}
window.clearAllFilters = clearAllFilters;

// Sets the map on all markers in the array.
const setAllMap = function (map) {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
    }
    if (myMarkerClusterer != null) {
        myMarkerClusterer.clearMarkers();
    }
}

// Deletes all markers in the array by removing references to them.
const deleteMarkers = function () {
    clearMarkers();
    markers = [];
}

//Close any open window
const closeInfoWindows = function () {
    var i = infowindows.length;
    while (i--) {
        infowindows[i].close();
    }
}

// Removes the markers from the map, but keeps them in the array.
const clearMarkers = function () {
    setAllMap(null);
}

const initMap = async () => {
    setOptions({
      key: 'AIzaSyAb1kvgMZKPL4xl0fbSSiqVvwLkHIPd0T4',
      version: 'weekly',
      libraries:['marker']
    });

    const { Map } = await importLibrary('maps');

    var minZoomLevel = 3;
    var mapOptions = {
        mapId: '62caf7139f6778166af14e91',
        zoom: minZoomLevel,
        minZoom: 2,
        maxZoom: 16,
        center: new google.maps.LatLng(39.7910, -86.1480),
        tileSize: new google.maps.Size(256, 256),
        rotateControl: false
    };

    gmap = new Map(document.getElementById('map'), mapOptions);
};

const initListeners = function () {
    const propertyTypeChecks = document.getElementsByName("platform");
    const glaCategoryChecks = document.getElementsByName("glaCategory");
    const tenantTypeCheck = document.getElementById("luxurytenants");
    const regions = document.getElementsByName("region");

    document.querySelectorAll('.btn-sort').forEach(function (everybutton) {
        everybutton.addEventListener('click', function (e) {
            filteredMallList.reverse();
            getFilters();
        });
    });

    for (var i = 0; i < propertyTypeChecks.length; i++) {
        propertyTypeChecks[i].addEventListener("click", function () {
            getFilters();
        });
    }

    tenantTypeCheck.addEventListener("click", function () {
        getFilters();
    });

    for (var i = 0; i < glaCategoryChecks.length; i++) {
        glaCategoryChecks[i].addEventListener("click", function () {
            getFilters();
        });
    }
    for (var i = 0; i < regions.length; i++) {
        regions[i].addEventListener("click", function () {
            getFilters();
        });
    }
}

let filteredMallList = simonMallList_mallList;
if (filteredMallIds.length > 0) {
    const arrayMallIds = filteredMallIds.split(',');
    filteredMallList = filteredMallList.filter(mall => arrayMallIds.includes(mall.Id.toString()));
}

/* Get the query parameters */
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("location")) {
    inputSearch.value = urlParams.get("location");
    $.ajax({
        type: "GET",
        url: "/search/performsearch/" + urlParams.get("location"),
        dataType: "text",
        encode: true,
    }).done(function (data) {
        const arrayMallIds = data.split(',');
        filteredMallList = simonMallList_mallList.filter(mall => arrayMallIds.includes(mall.Id.toString()));
        getFilters();
    });
}
if (urlParams.has("gla")) {
    const glaArray = urlParams.get("gla").split(',');
    glaArray.forEach(element => {
        document.getElementById(element.toLowerCase()).checked = true;
    });
}
if (urlParams.has("platform")) {
    const platformArray = urlParams.get("platform").split(',');
    platformArray.forEach(element => {
        document.getElementById(element.toLocaleLowerCase()).checked = true;
    });
}
if (urlParams.has("region")) {
    switch (urlParams.get("region").toLowerCase()) {
        case "usa":
            document.getElementById("regionUSA").checked = true;
            break;
        case "international":
            document.getElementById("regionIntl").checked = true;
            break;
        default:
            document.getElementById("regionAll").checked = true;
    }
}
if (urlParams.has("luxurytenants")) {
    if (urlParams.get("luxurytenants") == "true") {
        document.getElementById("luxurytenants").checked = true;
    }
}

setClearFilterState();

/* sliding filter menu */
const darken_screen = function (yesno) {
    if (yesno == true) {
        document.querySelector('.screen-darken').classList.add('active');
    }
    else if (yesno == false) {
        document.querySelector('.screen-darken').classList.remove('active');
    }
}

function close_offcanvas() {
    darken_screen(false);
    document.querySelector('.mobile-offcanvas.show')?.classList.remove('show');
    document.body.classList.remove('offcanvas-active');
}

function show_offcanvas(offcanvas_id) {
    darken_screen(true);
    document.getElementById(offcanvas_id).classList.add('show');
    document.body.classList.add('offcanvas-active');
}

const createDataList = function () {

    /* create an array of objects */

    simonMallList_mallList.forEach(mall => ol.push({ label: mall.DisplayName, value: mall.DisplayName, url: mall.TargetUrl }));

    // get all states
    let s = new Array();
    simonMallList_mallList.forEach(state => s.push({ label: state.StateName, value: state.StateName }));
    s = s.filter(element => element.label != "");

    let c = new Array();
    simonMallList_mallList.forEach(mall => {
        if (mall.CountryCode != "USA" && mall.CountryCode != "CAN") {
            c.push({ label: mall.StateCode, value: mall.StateCode }); // country names are in StateCode property
        }
    });
    c.push({ label: "Canada", value: "Canada" });

    let cities = new Array();
    simonMallList_mallList.forEach(mall => {
        if (mall.CountryCode == "USA") {
            cities.push({ label: mall.City + ", " + mall.StateCode, value: mall.City + ", " + mall.StateCode })
        }
    });

    ol = ol.concat(s);
    ol = ol.concat(c);
    ol = ol.concat(cities);

    ol = ol.filter((value, index, self) =>
        index === self.findIndex((t) => (
            t.label === value.label // filter out duplicates
        ))
    );
    // sort the array alphabetically
    ol.sort((a, b) => {
        const valA = a.label.toUpperCase();
        const valB = b.value.toUpperCase();
        if (valA < valB) {
            return -1;
        } else {
            return 1;
        }
    });

    $("#inputSearch").autocomplete({
        source: ol,
        /*select: searchSelect,*/
        select: searchSelectV2,
        appendTo: "#searchForm"
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<div>" + item.label.replace("®", "<sup>®</sup>") + "</div>")
            .appendTo(ul);
    };

    function searchSelectV2(event, ui) {
        if (ui.item.url != undefined) {
            window.location.assign(ui.item.url);
        } else if (ol.some(element => element.label === ui.item.label)) {
            performAJAXSearch(ui.item.value);
        } else if (inputSearch.value == "") {
            let url = new URL(window.location);
            url.searchParams.delete('location');
            window.history.pushState({}, '', url);
            filteredMallList = simonMallList_mallList;
            getFilters();
            setClearFilterState();
        }
    }
}

const performAJAXSearch = function (s) {
    $.ajax({
        type: "GET",
        url: "/search/performsearch/" + s,
        dataType: "text",
        encode: true,
    }).done(function (data) {
        const arrayMallIds = data.split(',');
        filteredMallList = simonMallList_mallList.filter(mall => arrayMallIds.includes(mall.Id.toString()));
        getFilters();
        setClearFilterState();
    });
}

$(document).ready(function () {
    $("form").submit(function (event) {
        if (inputSearch.value != "") {
            performAJAXSearch(inputSearch.value);
        }
        event.preventDefault();
    });

    createDataList();

    (async () => {
        await initMap();
        await getFilters();
    })();

    initListeners();

    document.querySelectorAll('[data-trigger]').forEach(function (everyelement) {
        let offcanvas_id = everyelement.getAttribute('data-trigger');
        everyelement.addEventListener('click', function (e) {
            e.preventDefault();
            show_offcanvas(offcanvas_id);
        });
    });

    document.querySelectorAll('.btn-close').forEach(function (everybutton) {
        everybutton.addEventListener('click', function (e) {
            close_offcanvas();
        });
    });

    document.querySelector('.screen-darken').addEventListener('click', function (event) {
        close_offcanvas();
    });

    if (urlParams.has("view") && urlParams.get("view") == "map") {
        document.getElementById('mapView').checked = true;
        showHideMap();
    }

});

$("#inputSearch").keypress(function (e) {
    if (!e) e = window.event;
    if (e.keyCode == '13') {
        $("#inputSearch").autocomplete('close');
        performAJAXSearch(inputSearch.value);
        return false;
    }
});

document.querySelectorAll('#collapseFilter input[type="radio"], #collapseFilter input[type="checkbox"]').forEach(function (input) {
    input.addEventListener('change', function () {
        setClearFilterState();
    });
});
